import React from "react"
import AnimationComponent from "../../reusable/components/AnimationComponent/AnimationComponent"

type Props = {
    isBackgroundOn: boolean
    color?: string
    zIndex?: number
}

const BackgroundOverlay = ({isBackgroundOn, color = "rgba(0,0,0,0.7)", zIndex = 13000}: Props): React.ReactElement => {
	return (
		<AnimationComponent type="fade"
			inProp={isBackgroundOn} >
			<div className="position-fixed vh-100 vw-100"
				style={{
					backgroundColor: color,
					zIndex,
					top: 0
				}}>
			</div>
		</AnimationComponent>
	)
}

export default BackgroundOverlay
